import { z, isoZ } from 'my-zod'
import { DamageWaiverCasePartOrderOrderStatusEnum } from '../damage-waiver-case-enums'
import { partFragment } from './part-fragment'

export const partsOrderModel = z.object({
  id: z.string().uuid(),
  damageWaiverCaseShortId: z.string().nonempty(),
  invoiceNumber: z.string().min(0).max(50).nullable(),
  trackingNumber: z.string().min(0).max(50).nullable(),
  orderStatus: DamageWaiverCasePartOrderOrderStatusEnum,
  invoiceTotal: z.number().min(0).setLabel('Invoice Total (Cost)'),
  parts: partFragment.array(),
  createdDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable(),
  lastModifiedDate: isoZ.instant()
})

export type partsOrderModel = z.infer<typeof partsOrderModel>
